<template>
  <router-view v-slot="{ Component }">
    <transition name="view" appear>
      <div class="k8-stat">
        <component :is="Component" />
      </div>
    </transition>
  </router-view>
</template>
<script>
export default {
  name: 'K8MStatefulsets',
  components: {},
};
</script>
<style scoped>
.k8-stat {
  width: 100%;
  height: 100%;
}
</style>
